import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../../../store/languageSlice';
import AddGuardian from './AddGuardian';
import EditGuardian from './EditGuardian';
import GuardianItem from './GuardianItem';

const MyGuardians = ({ data, onAddGuadrian, onDeletGuadrian, patientsRelations, onGuardianRemoveMsg, messageType = 'success' }) => {
  const { t } = useSelector(selectLanguage);
  const guardianId = data?.guardianId || null;
  const userDetails = data?.userDetails || null;
  const [guardianData, setGuardianData] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const onAddClick = () => {
    setShowEdit(true);
  };

  const onEditOrAddClick = (editData) => {
    setShowEdit(false);
    onAddGuadrian && onAddGuadrian(editData);
  };

  useEffect(()=>{
    setTimeout(()=>{
      setGuardianData(data?.guardianId ? data : null)
    },100)
  },[data])

  useEffect(()=> {
    setShowMessage(true);
    setGuardianData(null);
    setTimeout(() => {
      setShowMessage(false);
    }, 3000);
  },[onGuardianRemoveMsg])

  return (
    <div>
      <h3 className="pb-2 text-xl text-grey-700">{t.My_Guardians}</h3>

      {!guardianData && !showEdit && <AddGuardian handleOnAdd={onAddClick} />}
      {showEdit && (
        <EditGuardian patientsRelations={patientsRelations} data={guardianData} onAddGuadrian={onEditOrAddClick} />
      )}
      {guardianId && !showEdit && guardianData && (
        <GuardianItem
          data={guardianData}
          showEdit={onAddClick}
          handleOnDelete={onDeletGuadrian}
        />
      )}
      {showMessage && <p className={`font-medium mt-3 text-center ${messageType === 'fail' ? 'text-tertiary' : 'text-green'}`}>{onGuardianRemoveMsg}</p>}
    </div>
  );
};

export default MyGuardians;
